module.exports = __webpack_public_path__ + "static/img/image_support_article_details_11.0b4b571.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_article_details_11.png
// module id = ScU3
// module chunks = 10